import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Directive, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UnSubscribable } from '@core/un-subscrible';
import { Subject } from 'rxjs';
import { delay, skip, takeUntil } from 'rxjs/operators';

@Directive({
    selector: 'cdk-virtual-scroll-viewport[eigScrollToLast]'
})
export class EigScrollToLastDirective extends UnSubscribable implements OnInit, AfterViewInit, OnChanges {
    @Input()
    scrollSpacerHeight: number;

    private readonly _startScrollToBottom = new Subject();
    private readonly itemSize: number;
    private get lastScrollItem(): HTMLElement {
        return this.cdkVirtualScroll.elementRef.nativeElement.getElementsByClassName('eig-last-item')[0] as HTMLElement;
    }

    constructor(private cdkVirtualScroll: CdkVirtualScrollViewport) {
        super();
        this.itemSize = Number(this.cdkVirtualScroll.elementRef.nativeElement.getAttribute('itemSize'));
        this._startScrollToBottom
            .pipe(skip(1), delay(0))
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe({
                next: () => {
                    this.cdkVirtualScroll.scrollTo({
                        bottom: 0,
                        behavior: 'smooth'
                    });
                }
            });

        this.cdkVirtualScroll
            .elementScrolled()
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe({
                next: (event: any) => {
                    this.lastScrollItem?.focus();
                }
            });
    }
    ngOnChanges(changes: SimpleChanges): void {
        const scrollSpacerHeightChanges = changes['scrollSpacerHeight'];
        if (scrollSpacerHeightChanges && scrollSpacerHeightChanges.currentValue >= scrollSpacerHeightChanges.previousValue) {

            this.lastScrollItem?.focus();
            if (this.cdkVirtualScroll?.getViewportSize() < this.scrollSpacerHeight + this.itemSize) {
                this._startScrollToBottom.next();
            }
        }
    }
    ngOnInit(): void {}

    ngAfterViewInit(): void {}
}
